import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-eq-part": "io-card-recommendation"
}
const _hoisted_2 = {
  key: 0,
  class: "io-card__recommendation",
  "data-eq-part": "io-card-recommendation"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "io-card__body" }
const _hoisted_5 = { class: "io-card__icon" }
const _hoisted_6 = { "data-eq-part": "io-card-button" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_IoText = _resolveComponent("IoText")!
  const _component_ProductContent = _resolveComponent("ProductContent")!
  const _component_GridCol = _resolveComponent("GridCol")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_IoSpacer = _resolveComponent("IoSpacer")!
  const _component_GridRow = _resolveComponent("GridRow")!
  const _component_IoButton = _resolveComponent("IoButton")!
  const _component_Calculator = _resolveComponent("Calculator")!
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "io-card-wrapper io-eq-el",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hovering = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hovering = false))
  }, [
    (!(_ctx.product && _ctx.product.recommended))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["io-card", _ctx.classes])
    }, [
      (_ctx.product && _ctx.product.recommended)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "font-h4",
              innerHTML: _ctx.showAlternativeRecommendationText ? _ctx.product.recommendationTextSingle : _ctx.product.recommendationText
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasMedia)
        ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
            key: 1,
            "media-sizes": _ctx.mediaSizes,
            "background-position-y": _ctx.backgroundPositionY,
            "background-position-x": _ctx.backgroundPositionX,
            "media-mobile-sizes": _ctx.mediaMobileSizes,
            "background-position-mobile-y": _ctx.backgroundPositionMobileY,
            "background-position-mobile-x": _ctx.backgroundPositionMobileX,
            class: "io-card__media"
          }, null, 8, ["media-sizes", "background-position-y", "background-position-x", "media-mobile-sizes", "background-position-mobile-y", "background-position-mobile-x"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "prebody"),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.type === 'product')
          ? (_openBlock(), _createBlock(_component_ProductContent, {
              key: 0,
              product: _ctx.product,
              hovering: _ctx.hovering,
              "content-first": !!parseInt(_ctx.productContentFirst, 10)
            }, _createSlots({
              default: _withCtx(() => [
                (_ctx.hasHeadline)
                  ? (_openBlock(), _createBlock(_component_IoHeadline, {
                      key: 0,
                      size: "h3",
                      align: "start",
                      "text-align": "start",
                      "data-eq-part": "io-card-headline"
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "headline")
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_ctx.hasContent)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      (_ctx.hasContent)
                        ? (_openBlock(), _createBlock(_component_IoText, {
                            key: 0,
                            "text-align": "start",
                            "data-eq-part": "io-card-text"
                          }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "default")
                            ]),
                            _: 3
                          }))
                        : _createCommentVNode("", true)
                    ])
                  }
                : undefined
            ]), 1032, ["product", "hovering", "content-first"]))
          : _createCommentVNode("", true),
        (_ctx.type !== 'product')
          ? (_openBlock(), _createBlock(_component_GridRow, {
              key: 1,
              g: "0",
              "vertical-center": ""
            }, {
              default: _withCtx(() => [
                (_ctx.type === 'icon')
                  ? (_openBlock(), _createBlock(_component_GridCol, {
                      key: 0,
                      s: "auto",
                      class: "io-card__icon-mh"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === 'icon')
                  ? (_openBlock(), _createBlock(_component_GridCol, {
                      key: 1,
                      s: "auto"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_GridCol, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_GridRow, {
                      g: "0",
                      "vertical-center": "",
                      "data-eq-part": _ctx.type === 'icon' ? 'io-card-icon-row' : null
                    }, {
                      default: _withCtx(() => [
                        (_ctx.type === 'icon')
                          ? (_openBlock(), _createBlock(_component_GridCol, {
                              key: 0,
                              s: "auto",
                              class: "io-card__icon-fh"
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_GridCol, {
                          "vertical-center": _ctx.type === 'icon'
                        }, {
                          default: _withCtx(() => [
                            (_ctx.hasHeadline)
                              ? (_openBlock(), _createBlock(_component_IoHeadline, {
                                  key: 0,
                                  size: "h3",
                                  align: _ctx.textAlign,
                                  "text-align": _ctx.textAlign,
                                  "data-eq-part": _ctx.type === 'icon' ? null : 'io-card-headline'
                                }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "headline")
                                  ]),
                                  _: 3
                                }, 8, ["align", "text-align", "data-eq-part"]))
                              : _createCommentVNode("", true),
                            (_ctx.hasHeadline && _ctx.hasContent)
                              ? (_openBlock(), _createBlock(_component_IoSpacer, {
                                  key: 1,
                                  size: "medium"
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.hasContent)
                              ? (_openBlock(), _createBlock(_component_IoText, {
                                  key: 2,
                                  "text-align": _ctx.textAlign,
                                  "data-eq-part": _ctx.type === 'icon' ? null : 'io-card-text'
                                }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "default")
                                  ]),
                                  _: 3
                                }, 8, ["text-align", "data-eq-part"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 3
                        }, 8, ["vertical-center"])
                      ]),
                      _: 3
                    }, 8, ["data-eq-part"])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.showButton && !_ctx.showProductCalculator)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_IoSpacer, { size: "medium" }),
                _createVNode(_component_IoButton, {
                  "page-url": _ctx.pageUrl,
                  align: _ctx.type !== 'product' ? _ctx.textAlign : 'start'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", { innerHTML: _ctx.label }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                }, 8, ["page-url", "align"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.showProductCalculator)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_IoSpacer, { size: "medium" }),
                _createVNode(_component_Calculator, {
                  "product-id": _ctx.productId,
                  "show-product-name": 0,
                  branches: "all",
                  type: "component",
                  buttonLabel: "Preis berechnen"
                }, null, 8, ["product-id"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showFullLink)
        ? (_openBlock(), _createBlock(_component_IoRouterLink, {
            key: 2,
            "link-url": _ctx.pageUrl || '#',
            class: "io-card__link"
          }, null, 8, ["link-url"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 32))
}